import { render, staticRenderFns } from "./LockerHome.vue?vue&type=template&id=1968f102"
import script from "./LockerHome.vue?vue&type=script&lang=js"
export * from "./LockerHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports